import {
  CustomField,
  CustomFieldSelectedOption,
} from 'admin/customFields/entities/customFields.entity';
import { isEmpty } from 'lodash';

export const normalizeCustomFieldLabel = (label: string) => {
  return label.toLowerCase();
};

export const findDisplayValueByValueForDropdown = (
  customFieldsOptions: CustomFieldSelectedOption[],
  value: string | null,
) => {
  if (!value) {
    return null;
  }
  const normalizedValue = value.toString();
  const option = customFieldsOptions.find((option) => {
    const normalizedOptionId = option.id?.toString();
    return normalizedOptionId === normalizedValue;
  });

  if (!option) {
    throw new Error('selected option not found');
  }

  return option.label;
};

export const findCustomFieldDefinitionById = (
  customFieldDefinitions: CustomField[],
  customFieldDefinitionId: string,
) => {
  return customFieldDefinitions?.find((value) => value.id.toString() === customFieldDefinitionId);
};

export const findCustomFieldOptionDefinitionById = (
  customFieldDefinition: CustomField,
  customFieldOptionDefinitionId: string,
) => {
  return customFieldDefinition.selectionOptions.find(
    (value) => value.id?.toString() === customFieldOptionDefinitionId,
  );
};

export const filterEmptyCustomFieldsValues = (value: string | string[]) => {
  const isDropdownCustomFields = Array.isArray(value);
  if (isDropdownCustomFields && isEmpty(value)) {
    return false;
  }

  return !!value;
};
